import Repository from './Repository'

const resource = 'search'

export default {
  search (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
